import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';

import moment from 'moment-timezone';

import { getFormattedTimezone } from '@recruitee/time';
import { deepClone, includesWithTrim } from '@recruitee/utils';

import { InputComponent } from '../../input/input.component';

interface TimezoneListItem {
  timezone: string;
  timezoneFormatted: string;
}

@Component({
  selector: 'rt-time-zone-picker-dropdown-list',
  templateUrl: './time-zone-picker-dropdown-list.component.html',
  styleUrls: ['./time-zone-picker-dropdown-list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeZonePickerDropdownListComponent {
  @Output() public zoneSelect: EventEmitter<string> = new EventEmitter();

  @ViewChild('searchInput', { static: true }) public searchInput: InputComponent;

  public filteredZones: TimezoneListItem[];
  public isEmpty: boolean = true;

  private timeZonesList: TimezoneListItem[];

  constructor(protected cdRef: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.timeZonesList = moment.tz
      .names()
      .map(tz => ({ timezone: tz, timezoneFormatted: getFormattedTimezone(tz) }));
    this.filteredZones = deepClone(this.timeZonesList);
    this.cdRef.detectChanges();
  }

  public onInputChange(event: any): void {
    this.searchInput.setValue(event.target.value);
    this.isEmpty = event.target.value.length === 0;
    const query = event.target.value;
    this.filteredZones = this.timeZonesList.filter(zone => includesWithTrim(zone.timezone, query));
    this.cdRef.detectChanges();
  }

  public clearField(): void {
    this.searchInput.input.nativeElement.value = '';
    this.searchInput.setValue('');
    this.filteredZones = deepClone(this.timeZonesList);
    this.cdRef.detectChanges();
  }

  public trackByZone(index: number, timezone: TimezoneListItem): TimezoneListItem {
    return timezone;
  }
}
